// removed by extract-text-webpack-plugin
module.exports = {"header":"Vv1qXxkgQqIPJEI4EDXM3","logoContainer":"_3SDb7rqhMbjfFgvDV1mQxH","logoImage":"DwpWjO1eKbU8BWoBBL6Lk","logoutContainer":"_37KrpsSRobI-T-qqh9ueZT","logoutButton":"_1bOUre5bQGeOm6AZdyy8I","headerLinks":"_LDRw5KlAmRjDN6v3VLWl","accountLink":"_3VBp0jcMrKibUHLr4bz2Ae"};


//////////////////
// WEBPACK FOOTER
// ./client/src/styles/Header.scss
// module id = 470
// module chunks = 0